import Helmet from "react-helmet"
import { withPrefix, Link } from "gatsby"
import PropTypes from "prop-types"
import React, { useState } from "react"
import styled from "styled-components"
import Logo from '../images/strendingur_logo.png'

const Header = ({ siteTitle }) => {
  const [burgerToggled, setburgerToggled] = useState(false)

  const toggleBurger = () => setburgerToggled(!burgerToggled)

  return (
    <nav
      class="navbar is-primary"
      role="navigation"
      aria-label="main navigation"
    >
      <div class="container is-fluid">
        <div class="navbar-brand">
          <a class="navbar-item" href="http://strendingur.is/">
            <img
              src={Logo}
              width="225px"
            ></img>
          </a>
          <a
            role="button"
            class={`navbar-burger burger ${burgerToggled ? "is-active" : ""}`}
            onClick={toggleBurger}
            aria-label="menu"
            aria-expanded="false"
            data-target="navbarBasicExample"
          >
            <span aria-hidden="true"></span>
            <span aria-hidden="true"></span>
            <span aria-hidden="true"></span>
          </a>
        </div>

        <div
          class={`navbar-menu ${burgerToggled ? "is-active" : ""}`}
          onClick={toggleBurger}
        >
          <div class="navbar-end">
            <Link
              to="/"
              class="navbar-item"
              activeClassName="navbar-item navbar-item-selected"
            >
              Forsíða
            </Link>
            <a
              href="http://13.74.170.41/"
              class="navbar-item"
              activeClassName="navbar-item navbar-item-selected"
            >
              Útboðsvefur
            </a>
            <Link
              to="/projects"
              class="navbar-item"
              activeClassName="navbar-item navbar-item-selected"
            >
              Verkefni
            </Link>
            <Link
              to="/about"
              class="navbar-item"
              activeClassName="navbar-item navbar-item-selected"
            >
              Um okkur
            </Link>
          </div>
        </div>
      </div>
    </nav>
  )
}

export default Header
